import React, { useEffect, useState } from 'react'
import { I18n } from 'react-redux-i18n'
import _ from 'lodash'

import ModalWrapper from 'components/ModalWrapper'
import { Button } from 'components/Form'
import { getStaticImage } from 'utils/statics'
import Nixi1Spinner from 'components/Nixi1Spinner'

import './styles.scss'

const getLegend = (typeMessage) => {
  switch(typeMessage) {
    case 'init':
      return 'channels_imap_msg_init_verification'
    case 'success':
      return 'channels_imap_msg_success_verification'
    case 'changes':
      return 'channels_imap_msg_changes_verification'
    default:
      return 'channels_imap_msg_init_verification'
  }
}

const getIcon = (typeMessage) => {
  switch(typeMessage) {
    case 'success':
      return (<img className={`check-ok-image`} alt={'check'} src={getStaticImage(`/icons/orange-brand/icon-check-full.svg`)}/>)
    case 'changes':
      return (<img className='check-ok-image' src={getStaticImage(`/icons/orange-brand/icon-check-green.svg`)} alt='warning' />)
    case 'error':
      return (<img className='check-ok-image' src='img/icons/icon-warning-red.svg' alt='remove' />)
    case 'autoconfig_error':
      return (<img className='check-ok-image' src='img/icons/icon-warning-yellow.svg' alt='warning' />)
    default:
      return ''
  }
}

const ImapVerificationModal = (props) => {
  const { isOpen, toggle, isLoading, typeMessage, changes, errors, applyChanges } = props

  const imapError = _.get(errors, 'imap.sendVerificationError')
  const smtpError = _.get(errors, 'smtp.sendVerificationError')

  const [existsError, setExistsError] = useState(false)
  const [existsChanges, setExistsChanges] = useState(false)

  useEffect(() => {
    setExistsError(imapError || smtpError)
  }, [imapError, smtpError])

  useEffect(() => {
    const { changes } = props
    setExistsChanges(changes.imap.length > 0 || changes.smtp.length > 0)
  }, [props])


  
  return (
    <ModalWrapper
      id={'modalImapValidation'}
      header=' '
      body={
        
        <div className='delegate-ok-wrapper'>
          {
            isLoading
              ? <Nixi1Spinner height='88px'/>
              : getIcon(typeMessage)
          }

          {
            !['error', 'autoconfig_error'].includes(typeMessage) &&
            <div className={ existsChanges ? 'imap-changes-warning' : '' }>
              {
                existsChanges && <img className='check-ok-image' src='img/icons/icon-warning-yellow.svg' alt='warning' />
              }
              <legend>{`${I18n.t(getLegend(typeMessage))}`}</legend>
            </div>
          }

          {
            existsChanges && <div className='imap-changes-list'>
              {
                !!changes.imap.length && <>
                  <h5>IMAP</h5>
                  {changes.imap.map((change, index) => {
                    return (
                      <p key={index}>
                        - {I18n.t(change.msg)} <b>({change.previousLabel ? I18n.t(change.previousLabel) : change.previous} -&gt; {change.currentLabel ? I18n.t(change.currentLabel) : change.current})</b>
                      </p>)
                  })}
                </>
              }

              {
                !!changes.smtp.length && <>
                  <h5>SMTP</h5>
                  {changes.smtp.map((change, index) => {
                    return (
                      <p key={index}>
                        - {I18n.t(change.msg)}
                        <b>
                          ({change.previousLabel ? I18n.t(change.previousLabel) : change.previous} -&gt; {change.currentLabel ? I18n.t(change.currentLabel) : change.current})
                        </b>
                      </p>)
                  })}
                </>
              }
            </div>
          }
          
          {
            existsError && <div className='imap-error-list'>
              {
                imapError === smtpError
                  ? <legend>{I18n.t(imapError)}</legend>
                  : <>
                    {imapError && <legend><b>IMAP</b>: {I18n.t(imapError)}</legend>}
                    {smtpError && <legend><b>SMTP</b>: {I18n.t(smtpError)}</legend>}
                  </>
              }
            </div>
          }
          {
            !isLoading && <>
              {
                existsChanges
                  ? <>
                    <div className='modal-imap-btns'>
                      <Button className={'button-back'} value={`${I18n.t('channels_imap_btn_reject_changes')}`} onClick={() => {
                        applyChanges({ rejecChanges: true })
                        toggle()
                      }} />
                      <Button secondary className={'btn-accept-changes'} value={`${I18n.t('channels_imap_btn_apply_changes')}`} onClick={() => {
                        applyChanges({ rejecChanges: false })
                        toggle()
                      }} />
                    </div>
                  </>
                  : <Button secondary value={`${I18n.t('dashboard_ok')}`} onClick={toggle} />
              }
            </>
          }

        </div>
      }
      isOpen={isOpen}
      toggle={toggle}
      showClose={false}
      backdrop={'static'}
    />
  )
}

export default ImapVerificationModal
